<template>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <h3>Potential</h3>
                <div class="field  grid">
                    <label for="dd" class="col-12 mb-2 md:col-3 md:mb-0 font-medium">Input Employee Name</label>
                    <div class="col-12 md:col-5">
                        <AutoComplete forceSelection placeholder="Search" id="dd" :dropdown="true" v-model="employee"
                        :suggestions="autoFilteredValue" @complete="searchAssessor($event)" @item-select="selectEmployee()" field="name" :disabled="isSelected"
                        :class="{ 'p-invalid': submitted && !form.employee_id }"/>
                        <small class="p-invalid" v-if="submitted && !form.employee_id">
                            Assessor is required.
                        </small>
                        <Button label="Remove" class="p-button-primary mr-2 ml-2" @click="clearSelected" :disabled="!isSelected"/>
                    </div>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-3 md:mb-0">NIK</label>
                    <div class="col-12 md:col-5">
                        {{ employee.nik }}
                    </div>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-3 md:mb-0">Name</label>
                    <div class="col-12 md:col-5">
                        {{ employee.name }}
                    </div>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-3 md:mb-0">Placement</label>
                    <div class="col-12 md:col-5">
                        <Dropdown
                            v-model="employee.placement_id" :options="placements" optionLabel="name" optionValue="id"
                            placeholder="Select Placement" disabled="true" />
                    </div>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-3 md:mb-0">Division</label>
                    <div class="col-12 md:col-5">
                        <Dropdown v-model="employee.division_id"
                            :options="divisions" optionLabel="name" optionValue="id" placeholder="Select Division"
                         disabled="true" />
                    </div>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-3 md:mb-0">Position</label>
                    <div class="col-12 md:col-5">
                        <Dropdown v-model="employee.position_id"
                            :options="positions" optionLabel="name" optionValue="id" placeholder="Select Position"
                         disabled="true" />
                    </div>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-3 md:mb-0">Position Class</label>
                    <div class="col-12 md:col-5">
                        <Dropdown
                            v-model="employee.position_class_Id" :options="positionClasses" optionLabel="name"
                            optionValue="id" placeholder="Select Position Class" disabled="true" />
                    </div>
                </div>
                <hr />
                <div class="field grid" v-if="form.is_not_agree">
                    <label for="reason" class="col-12 mb-2 md:col-2 md:mb-0">Reason</label>
                    <div class="col-12 md:col-5">
                        <Textarea>Asasdjnkasd</Textarea>
                    </div>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-3 md:mb-0">Assessor Name</label>
                    <div class="col-12 md:col-5">
                        <AutoComplete forceSelection placeholder="Search" id="dd" :dropdown="true"
                            :disabled="disabled"
                            v-model="form.assessor" :suggestions="autoFilteredValue"
                            @complete="searchAssessor($event)" @item-select="selectAssessor" field="name"
                            :class="{ 'p-invalid': submitted && !form.assessor }"
                         />
                        <small class="p-invalid" v-if="submitted && !form.assessor">
                            Assessor is required.
                        </small>
                    </div>
                </div>
                <div class="field grid">
                    <label for="reason" class="col-12 mb-2 md:col-3 md:mb-0">Resume Test</label>
                    <div class="col-12 md:col-5">
                        <Textarea v-model="form.resume_test" rows="5" cols="70">Asasdjnkasd</Textarea>
                        <small class="p-invalid" v-if="submitted && !form.resume_test">
                            Resume Test is required.
                        </small>
                    </div>
                </div>
                <Button :loading="isSaving" @click="save" id="button1" label="Next" />
            </div>
        </div>
    </div>
</template>
<script>
import AppLayout from '../../Layouts/AppLayout';
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import axios from 'axios';
export default {
    layout: AppLayout,
    components: {
        AutoComplete,
        Button,
        Calendar,
        Dropdown,
        InputText,
        Textarea,
    },
    props: ['model','submitted','disabled'],
    data() {
        return {
            form: this.$page.props.employeePotential ?? {employee_id: '', assessor_id: '', resume_test: ''},
            placements: [],
            divisions: [],
            positions: [],
            positionClasses: [],
            employee: [],
            autoFilteredValue: [],
            assessorPosition: '',
            isSelected: false,
            submitted: false,
            isSaving: false,
            isEdit: false,
            model: {},
        }
    },
    mounted() {
        if(this.$page.props.employeePotential){
            this.isEdit = true;
            this.selectEmployee(this.$page.props.employeePotential.assessor_id);
        }
        this.loadData();
    },
    methods: {
        searchAssessor(event) {
            setTimeout(() => {
                if (!event.query.trim().length) {
                    axios.get(`${this.$page.props.appUrl}api/employees`)
                        .then((data) => {
                            this.autoFilteredValue = data.data.data;
                        });
                }
                else {
                    let filterValue = event.query.toLowerCase();
                    axios.get(`${this.$page.props.appUrl}api/employees?search=${filterValue}`)
                        .then((data) => {
                            this.autoFilteredValue = data.data.data;
                        });
                }
            }, 250);
        },
        selectEmployee() {
            axios.get(`${this.$page.props.appUrl}api/employees/${this.employee.id}`)
            .then((data) => {
                this.form.employee_id = data.data.data.id;
                this.employee = data.data.data;
            });
        },
        selectAssessor() {
            axios.get(`${this.$page.props.appUrl}api/employees/${this.form.assessor.id}`)
            .then((data) => {
                this.isSelected = true;
                this.form.assessor_id = data.data.data.id;
            });
        },
        clearSelected(){
            this.employee  = '';
            this.isSelected = false;
        },
        loadData() {
            axios.get(`${this.$page.props.appUrl}api/placement-units`)
                .then((data) => {
                    this.placements = data.data;
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Can't Get Data Placement, Refresh Again in 5 second. If still not shown contact support",
                        life: 3000,
                    });
                });
            axios.get(`${this.$page.props.appUrl}api/divisions`)
                .then((data) => {
                    this.divisions = data.data;
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Can't Get Data Divisions, Refresh Again in 5 second. If still not shown contact support",
                        life: 3000,
                    });
                });
            axios.get(`${this.$page.props.appUrl}api/positions`)
                .then((data) => {
                    this.positions = data.data;
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Can't Get Data Positions, Refresh Again in 5 second. If still not shown contact support",
                        life: 3000,
                    });
                });
            axios.get(`${this.$page.props.appUrl}api/position-classes`)
                .then((data) => {
                    this.positionClasses = data.data;
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Can't Get Data Positions, Refresh Again in 5 second. If still not shown contact support",
                        life: 3000,
                    });
                });
        },
        save(){
            this.isSaving = true;
            this.submitted = true;
            if(this.isEdit){
                axios.put(`${this.$page.props.appUrl}api/employee-potential-tests/${this.$page.props.assessement.id}`,this.form)
                .then((data) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Candidate Training Updated",
                        life: 3000,
                    });
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error When Updating Training",
                        detail: error,
                        life: 3000,
                    });
                })

                this.isSaving = false;
            }
            else{
                axios.post(`${this.$page.props.appUrl}api/employee-potential-tests`,this.form)
                .then((data) => {
                    this.form = {employee_id: '', assessor_id: '', resume_test: ''};
                    this.submitted = false;
                    this.clearSelected();

                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Employee Potential Created",
                        life: 3000,
                    });
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error When Created Potential Report",
                        detail: error,
                        life: 3000,
                    });
                })

                this.isSaving = false;
            }
        },
    }
}
</script>
